// Recovered compiled webpack factory 87624. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n;
  r.d(t, { k3: () => u, lu: () => i, zf: () => s });
  var a = r(78714),
    o = r(49636);
  function i() {
    return (0, a.Wk)() / 1e3;
  }
  function s() {
    return (
      n ??
      (n = (function () {
        let { performance: e } = o.O;
        if (!e?.now || !e.timeOrigin) return i;
        let t = e.timeOrigin;
        return () => (t + (0, a.Qw)(() => e.now())) / 1e3;
      })())
    )();
  }
  let l = null;
  function u() {
    return (
      null === l &&
        (l = (function () {
          let { performance: e } = o.O;
          if (!e?.now) return;
          let t = (0, a.Qw)(() => e.now()),
            r = (0, a.Wk)(),
            n = e.timeOrigin;
          if ("number" == typeof n && 3e5 > Math.abs(n + t - r)) return n;
          let i = e.timing?.navigationStart;
          return "number" == typeof i && 3e5 > Math.abs(i + t - r) ? i : r - t;
        })()),
      l
    );
  }
}
